<script setup>
	import { ref, onMounted, onBeforeUnmount, watch } from "vue";
	import { useRouter } from 'vue-router'

    //reactive field proxies
	const activeId = ref(0);
	const topicRefs = ref({}); 
	const topics = ref({})
    const sections = ref([])

	//local variables
	const router = useRouter()
	let observer;

    //properties set by parent
    const props = defineProps({
    topic: {
        type: Object,
        required: true,
    }
    })

    //reactive field proxies
    const topic = ref(props.topic)

	//Methods	
	async function runSetup() {
        topics.value = [
            {
                "title" : "Contact Us",
                "anchor" : "Contact Us",
                "id" : 0
            },
            {
                "title" : "Permissions",
                "anchor" : "Permissions",
                "id" : 1
            },
            {
                "title" : "Get Email Updates from NCSES",
                "anchor" : "Get Email Updates from NCSES",
                "id" : 2
            }
        ]
	}

	runSetup() 

	onMounted(() => {
		observer = new IntersectionObserver(
			(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					activeId.value = entry.target.id;
				}
			});
			},
			{ threshold: 0.8 }
		);
        // Observe all sections
        document.querySelectorAll('section').forEach((section) => {
            observer.observe(section);
        });

		/*watch(topicRefs.value, () => {
            console.log('activeId:',activeId)
			if('0' in topicRefs.value) {
				topics.value.forEach((section, index) => {
					if (topicRefs.value[index]) {
						observer.observe(topicRefs.value[index]);
					}
				});
			}
		})*/

        // Digital Analytics Program (https://digital.gov/guides/dap) 
        if(import.meta.env.VITE_APP_ENV && import.meta.env.VITE_APP_ENV === 'production') {
            const dapScript = document.createElement("script");
                dapScript.setAttribute("async", "")
                dapScript.setAttribute("id","_fed_an_ua_tag");
                dapScript.setAttribute("type","text/javascript");
                dapScript.setAttribute("src","https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js?agency=NSF");
            document.head.appendChild(dapScript);
        }
        
	});

	onBeforeUnmount(() => {
		if (observer) observer.disconnect();
	});

    /*function showHomePageError(msg) {
		const msgObj = {
			"text": msg.message?msg.message:msg,
			"type": "error"
		}
		router.push({
			name: 'HomeView',
			state: { "msgObj": msgObj } // stored in history.state, not URL
		}) 
	}*/
	
</script>
<template>
    <div class="page-container">
        <div class="page-contents">
            
            <div class="toc-header">
                <h2>ON THIS PAGE</h2>
                <ul>
                    <li v-for="(topic, index) in topics" :key="index">
                    <a
                        :href="`#${topic.id}`"
                        :class="{ active: activeId.value == topic.id}">
                        <span>{{ topic.anchor }}</span>
                    </a>
                    </li>
                </ul>
            </div>

            <div class="section-container">
                <div class="main-content">

                    <section class="page-section" style="padding-top: 3rem;" :key="0" :id="0" :ref="sections" :topic="topic">
                        <h2 class="title">Contact Us</h2>
                        <div class="separator-line"></div>

                        <p><strong>National Center for Science and Engineering Statistics</strong><br />
                        Randolph Building, 401 Dulany Street<br />
                        Alexandria, VA 22314, USA<br />
                        Phone: (703) 292-8780<br />
                        Fax: (703) 292-9092<br /><br />

                        <a class="email_address" href="mailto:ncsesweb@nsf.gov">ncsesweb@nsf.gov</a></p>
                    </section>

                    <div class="alt-color">
                        <section class="page-section" :key="1" :id="1" :ref="sections" :topic="topic">
                            <h2 class="title">Permissions</h2>
                            <div class="separator-line"></div>
                            <p class="">Reports and other products from the National Center for Science and Engineering Statistics (NCSES) within the National Science Foundation (NSF) are works of the U.S. federal government. You may freely use material from NCSES, including data and individual tables and figures, unless a copyright is specifically noted. A specific suggested citation typically will be provided within NCSES reports. If the suggested citation is not available to you or the content does not have one, our general citation is as follows:</p>
                            <p class="">National Center for Science and Engineering Statistics (NCSES). Year of product. Title of product. Publication number, if available. Alexandria, VA: National Science Foundation. Available at [URL of product].</p>
                            <p class="">We also appreciate being notified (<a class="email_address" href="mailto:ncsesweb@nsf.gov">ncsesweb@nsf.gov</a>) when work that cites NCSES data is published.</p>
                            <p class="">If copyrighted material is included on an NCSES Web page or in an NCSES report, it will be specifically noted. It is the policy of NSF to use externally produced material (graphics, text, etc.) only with permission of the copyright holder. For more information on NSF policy on copyright and reuse of graphics and text, please see <a href="https://www.nsf.gov/policies/reuse.jsp" target="_blank">https://www.nsf.gov/policies/reuse.jsp <i class="fa-solid fa-arrow-up-right-from-square"></i></a>.</p>
                        </section>
                    </div>
                    
                    <section class="page-section" :key="2" :id="2" :ref="sections" :topic="topic">
                        <h2 class="title">Get Email Updates from NCSES</h2>
                        <div class="separator-line"></div>
                        <p class="">NCSES is an official statistical agency. Subscribe to receive our latest news and announcements. 
                            <a href="https://public.govdelivery.com/accounts/USNSF/subscriber/new?topic_id=USNSF_66" target="_blank">Subscribe <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                        </p>
                        
                    </section>
                </div>

                <!-- Sidebar -->
                <aside class="sidebar">
                    <h2>ON THIS PAGE</h2>
                    <ul>
                        <li v-for="(topic, index) in topics" :key="index">
                        <a
                            :href="`#${topic.id}`"
                            :class="{ active: activeId == topic.id}">
                            <span>{{ topic.anchor }}</span>
                        </a>
                        </li>
                    </ul>
                </aside>
                
		    </div>
        </div>
	</div>
</template>

<style scoped>
.page-container {
    display: block;
    min-width: 375px;
    width: 100%;
    /* height: 55rem; */
    transition: max-width .2s linear;
    border-radius: 0.75rem;
    background-color: var(--surface-color-Default, #fff);
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.10);
    line-height: 1.5;
    background-color: var(--surface-color-Default, #fff);
}
.page-contents {
    margin-bottom: 1.5rem;
}
.page-section {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    /* border-bottom: 1px solid #ddd; */
    padding: var(--spacing-7xl) var(--spacing-4xl);
    max-width: 72.5rem;
    margin-right: 14.5625rem;
}
.email_address {
    color: var(--text-Link);
    text-decoration: none;
	font-weight: 500;
}
.email_address:hover {
    text-decoration: underline;
}
p a {
    color: var(--text-Link);
    text-decoration: none;
	font-weight: 500;	
}
.title {
    font-size: var(--font-size-H2);
    font-family: var(--font-family-Title, Roboto);
    font-weight: 500;
    color: var(--text-text-Header);
    line-height: var(--font-line-height-H2);
    margin: 0;
}
.separator-line {
    width: 5rem;
    height: 0.375rem;
    background-color: #005495;
    margin: 1.625rem 0;
}
.toc-header {
	display: none;
	background: var(--surface-color-Tertiary);
	padding: var(--spacing-7xl) var(--spacing-4xl);
}
.section-container {
	display: flex;
	min-height: 100vh;
	/*margin-top: var(--spacing-4xl); */
}
.sidebar {
	width: 14.5625rem;
	position: sticky;
	top: 0;
	right: var(--spacing-4xl, 3rem);
	height: 100vh;
	background-color: transparent;
	padding: 1rem;
	margin-left: -14.5625rem;
}

.sidebar h2 {
	font-weight: bold;
	margin-bottom: 1rem;
}

.sidebar ul, .toc-header ul {
	list-style: none;
	padding: 0;
	margin: 0;
}

.sidebar h2, .toc-header h2 {
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Caption);
	font-weight: 500;
} 

.sidebar a, .toc-header a {
	display: block;
	padding: 0.5rem;
	border-radius: var(--radius-md);
	text-decoration: none;
	color: var(--text-MedGrey, #2c2c2c);
	cursor: pointer;
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base);
	font-weight: 400;	
}

.sidebar a .title, .toc-header a .title {
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H6);
	font-weight: 500;
}
.sidebar a:hover, .sidebar a:hover .title, 
.toc-header a:hover, .toc-header a:hover .title {
	font-weight: 700;
}

.sidebar a:focus, .toc-header a:focus{
	font-weight: 700;
	outline: 0;
	border: 1.5px solid var(--input-background-Active, #064291)
}

.sidebar a.active, .toc-header a.active {
	font-weight: 700;
	color: #005495;
;
}
.alt-color {
	background-color: var(--surface-color-Tertiary);
}
.main-content {
	flex: 1;
    align-items: flex-start;
    align-self: stretch;
}

input[type="email"] {
    width: 25rem;
    border-radius: .25rem;
}
/* Style when the input value is NOT a valid email address */
input[type="email"]:invalid {
    border-color: red;
}
.subscribe-button {
    padding-top: 0.5rem;
    margin-left: 0.5rem;
    width: 7rem;
    height: 2.5rem;    

}
.btn-primary {
    align-self: stretch;
    text-align: center;
    border-radius: .5rem;
    text-decoration: none;
}
.subtle-label {
	color: var(--text-Secondary, #757575);

	/* Medium/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */
}

/* 1023px - iPad */
@media (max-width: 63.9375rem) {
	.toc-header {
		display: block;
		padding: var(--spacing-xl);
	}

	.toc-header h2 {
		color: var(--text-Primary, #2C2C2C);
		font-size: var(--font-size-Caption, 14px);
		font-weight: 400;
		line-height: var(--font-line-height-Caption, 20px); /* 142.857% */
	}	

	.sidebar {
		display:none;
	}
}

</style>

